module.exports = __webpack_public_path__ + "img/t4-i19.27ea441b.jpg";